package com.cybersoftsolution.cybersoftsolutionweb.components.sidePanels

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint

val mouseOverColor = Theme.Withe.rgb
val selectedColor = Theme.Withe.rgb
//val unselectedColor = Theme.HalfBlack.rgb
val unselectedColor = Theme.HalfWithe.rgb


    @Composable
    inline fun SidePanel(
//        onMenuClick: () -> Unit = {}
        crossinline sidePanelInternalIsCurrentlyOpen: (Boolean) -> Unit = {}
    ){
        val breakpoint = rememberBreakpoint()

        var overFlowPanelIsOpen by remember { mutableStateOf(false) }
        var sidePanelInternalIsOpen by remember { mutableStateOf(true) }

        LaunchedEffect(sidePanelInternalIsOpen) {
            sidePanelInternalIsCurrentlyOpen(sidePanelInternalIsOpen)
        }


            if (breakpoint >= Breakpoint.MD){
                SidePanelCollapsed( onMenuClick = {sidePanelInternalIsOpen = !sidePanelInternalIsOpen} )
                SidePanelInternal(isOpen = sidePanelInternalIsOpen)


            }else{
                SidePanelCollapsed( onMenuClick = {overFlowPanelIsOpen = true} )

                if (overFlowPanelIsOpen) {
                    SidePanelOverFlow(onMenuCloseClick = {overFlowPanelIsOpen = false})
                }


            }





    }



